/**
 * Прив’язка полів модуля «content» до понять довідника (значок «?» біля підпису поля).
 * Ключ — `content.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary), напр. 'КЦ', 'ЦА'.
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Поле в інтерфейсі: <Field term="content.<сутність>.<поле>">.
 */
export const CONTENT_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Картка матеріалу
  'content.material.targetAudience': 'ЦА',
  'content.material.commercialValue': 'КЦ',
  'content.material.seoBrief': 'ТЗ',
  // Паспорт нової (посиленої) послуги
  'content.passport.targetAudience': 'ЦА',
  'content.passport.commercialValue': 'КЦ',
  // Звіти й процеси
  'content.report.newServices': 'Нові та РОЗВИТОК',
  'content.marketing.crm': 'CRM',
  'content.cjm.km': 'КМ',
};
